<template>
  <div class="merchant-center">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="logo-area">
        <!-- 这里可以替换为实际的logo图片路径 -->
        <img src="../../assets/image/logo48@2x.png" alt="logo" class="logo" />
        <span class="title">商户管理中心</span>
      </div>
      <div class="user-info">
        <span>欢迎您，测试</span>
        <button class="exit-btn" @click="logout()">退出</button>
      </div>
    </header>

    <!-- 主体内容区域 -->
    <main class="main-content">
      <!-- 用户信息模块 -->
      <div class="user-section">
        <img
          src="../../assets/image/logo48@2x.png"
          alt="用户头像"
          class="avatar"
        />
        <div class="user-detail">
          <span class="username">测试</span>
          <!-- <a href="javascript:;" class="modify-pwd">修改密码</a> -->
        </div>
      </div>

      <!-- 商铺管理模块 -->
      <div class="shop-section">
        <h2 class="shop-title">我的商铺(2/100)</h2>
        <p class="shop-desc">
          每个商铺为独立运营的，会员是不通用的。每个商铺可以邀请合伙人一起管理
        </p>
        <!-- 商铺列表容器 -->
        <div class="shops-list">
          <!-- 单个商铺卡片 -->
          <div class="shop-card" v-for="(item, index) in shops" :key="index" @click="navigatorTo(item.shop_token)">
            <div class="shop-header">
              <div class="shop-name">{{ item.shop.name }} <span class="shop-type">({{item.shop.application.name}})</span></div>
              <span class="founder-tag">创始人</span>
            </div>
            <div class="shop-time">开通时间：{{ item.add_time_format }}</div>
          </div>
        </div>
        <button class="create-shop-btn" @click="addMerchant">+ 创建商铺</button>
      </div>

    </main>

    <div v-if="editMerchantLoading">
      <edit-merchant
        :aid="aid"
        :visible="editMerchantLoading"
        @cancel="cancelMerchant"
        @ok="okEditMerchant"
      ></edit-merchant>
    </div>
  </div>
</template>

<script>
import editMerchant from "./components/editMerchant.vue";
export default {
  name: "MerchantCenter",
  components: {
    editMerchant,
  },
  data() {
    return {
      editMerchantLoading: false,
      aid: 0,
      shops: []
    };
  },
  created() {
    let accToken = localStorage.getItem("account-token");
    if (!accToken) {
      this.$router.push("/ptlogin");
    }

    this.getSiteInfo(accToken)
    this.getAccountLayout(accToken)
    this.getAccountHome(accToken)
  },
  methods: {
    logout() {
      localStorage.removeItem("account-token");
      this.$router.push("/merchant/login");
    },
    addMerchant() {
      this.aid = 0;
      this.editMerchantLoading = true;
    },
    // editMerchant(record){
    //   this.aid=record.aid;
    //   this.editMerchantLoading=true;
    // },
    cancelMerchant() {
      this.editMerchantLoading = false;
    },
    okEditMerchant() {
      console.log('daozhelilema')
      this.editMerchantLoading = false;
      // this.getLists();
    },
    getSiteInfo(accToken) {
      this.$http.papi('platform/siteInfo',{
        auth_token: accToken
      })
    },
    getAccountLayout(accToken) {
      this.$http.papi('platform/account/layout',{
        auth_token: accToken
      })
    },
    getAccountHome(accToken) {
      this.$http.papi('platform/account/home',{
        auth_token: accToken
      })
      .then((res) => {
        if(res.mendian && res.mendian.length > 0) {
          this.shops = res.mendian
        }
      })
    },
    navigatorTo(shopToken) {
      const baseURL = process.env.VUE_APP_BASE_API;
      const url = `${baseURL}/beautiful#/auth?shop_token=${shopToken}`;
      window.location.href = url
    }
  },
};
</script>

<style scoped>
/* 整体容器样式 */
.merchant-center {
  font-family: "Microsoft Yahei", sans-serif;
  background-color: #fff;
  min-height: 100vh;
}

/* 顶部导航栏样式 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2e89fc;
  color: #fff;
  padding: 0 20px;
  height: 60px;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-info span {
  margin-right: 10px;
  font-size: 14px;
}

.exit-btn {
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.exit-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* 主体内容区域样式 */
.main-content {
  padding: 20px;
}

/* 用户信息模块样式 */
.user-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 15px;
}

.user-detail {
  display: flex;
  flex-direction: column;
}

.username {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.modify-pwd {
  font-size: 14px;
  color: #2e89fc;
  text-decoration: none;
}

.modify-pwd:hover {
  text-decoration: underline;
}

/* 商铺管理模块样式 */
.shop-section {
  padding: 20px;
}

/* 商铺列表容器：横向排列卡片，超出换行 */
.shops-list {
  display: flex;
  gap: 20px; /* 卡片之间的间距 */
  margin: 16px 0; /* 与上下内容的间距 */
  flex-wrap: wrap; /* 响应式换行 */
}

/* 单个商铺卡片：白色背景、阴影、圆角 */
.shop-card {
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: calc(50% - 10px); /* 两个卡片一行，减去间距 */
  box-sizing: border-box;
  cursor: pointer;
}

.shop-card:hover {
  background-color: rgba(46, 137, 252, 0.1);
}

/* 店铺头部：名称+类型 + 创始人标签 */
.shop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.shop-name {
  font-size: 16px;
  font-weight: bold;
}

.shop-type {
  font-size: 14px;
  color: #666;
  margin-left: 4px;
}

/* 创始人标签：蓝色边框+文字，圆角 */
.founder-tag {
  background-color: transparent;
  color: #2e89fc;
  border: 1px solid #2e89fc;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: default;
}

/* 开通时间：灰色文字，小字号 */
.shop-time {
  font-size: 14px;
  color: #999;
}

/* 创建商铺按钮：虚线边框+蓝色文字 */
.create-shop-btn {
  background-color: transparent;
  border: 1px dashed #2e89fc;
  color: #2e89fc;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  width: 100%; /* 按钮占满宽度 */
}

.create-shop-btn:hover {
  background-color: rgba(46, 137, 252, 0.1);
}
</style>
